export const formatBalance = (
    value: number,
    labelText: {
        thousand: string;
        millions: string;
    },
): string => {
    if (value < 1000) {
        return value.toString();
    }

    if (value < 1000000) {
        const thousands = value / 1000;
        const formatted = thousands.toFixed(0).replace('.', ',');

        return `${formatted} ${labelText.thousand}`;
    }

    const millions = value / 1000000;
    const formatted = millions.toFixed(0).replace('.', ',');

    return `${formatted} ${labelText.millions}`;
};
